export default {
    client: "Client",
    country: "Pays",
    in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days: "En cas de doute sur le fonctionnement de la plateforme, des points, ou toute information non liée au contenu des cours, remplissez le formulaire pour contacter notre équipe d'assistance.",
    subject: "Matière"
}